// Root ErrorBoundary — catches uncaught render errors so a single broken
// page doesn't dump the Vite dev overlay on the user. In production this
// is the difference between a friendly message and a white screen.

import { Link, isRouteErrorResponse, useRouteError } from 'react-router';
import { Logo } from './brand/Logo.tsx';
import { Button } from './ui/Button.tsx';

export function RootErrorBoundary() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : 500;
  const title =
    status === 404
      ? 'Page not found'
      : status === 401
        ? 'Sign in required'
        : 'Something went wrong';
  const message = isRouteErrorResponse(error)
    ? error.statusText || 'The page you were looking for could not be loaded.'
    : 'An unexpected error happened while loading this page. Please try again.';

  return (
    <main className="mx-auto flex min-h-dvh max-w-2xl flex-col items-start justify-center px-6 py-12">
      <Logo className="text-2xl" />
      <p className="mt-8 text-sm font-medium tracking-wide text-muted-foreground uppercase">
        {status === 404 ? '404' : 'Error'}
      </p>
      <h1 className="mt-2 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
        {title}
      </h1>
      <p className="mt-3 text-base text-muted-foreground">{message}</p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/">
          <Button variant="primary">Go home</Button>
        </Link>
        {status === 401 ? (
          <Link to="/sign-in">
            <Button variant="secondary">Sign in</Button>
          </Link>
        ) : (
          <Button variant="secondary" onClick={() => window.location.reload()}>
            Try again
          </Button>
        )}
      </div>
    </main>
  );
}
